export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/gig_page_perseus/loader.ba2b4df.gif";